import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { tenantIDAtom } from "atoms/GlobalAtoms";
import useUser from "../api/api-hooks/auth/useUser";
import { getUserPagePermissions } from "../utils/UserUtils";

const startingPermissions = () => ({
  page_create_page: false,
  page_modify_page: false,
  page_delete_page: false,
  page_modify_page_settings: false,
  page_get_page: false,
  page_get_pages: false,
  page_transfer_page: false,
  page_create_duplicate_page: false,
  page_create_view: false,
  page_modify_view: false,
  page_delete_view: false,
  page_create_duplicate_view: false,
  page_create_section: false,
  page_modify_section: false,
  page_delete_section: false,
  page_add_user: false,
  page_modify_user_permissions: false,
  page_delete_user: false,
  page_transfer_ownership: false,
});

// Gets the user's permissions for the current page
const usePagePermissions = (pageID) => {
  const tenantID = useAtomValue(tenantIDAtom);
  const { user, pPermissions: permissions } = useUser();

  const pagePermissions = useMemo(() => {
    const scopeMap = startingPermissions();

    if (!user || !pageID || !tenantID || !permissions) {
      return { pPermissions: scopeMap, pPermissionProfile: null };
    }

    const permissionProfile = getUserPagePermissions(
      user,
      tenantID,
      pageID,
      permissions
    );

    const scopes = permissionProfile?.Scopes;

    if (!scopes) {
      return { pPermissions: scopeMap, pPermissionProfile: null };
    }

    for (const scope of scopes) {
      scopeMap[scope] = true;
    }

    return { pPermissions: scopeMap, pPermissionProfile: permissionProfile };
  }, [permissions, pageID, user, tenantID]);

  return (
    pagePermissions || {
      pPermissions: startingPermissions(),
      pPermissionProfile: null,
    }
  );
};

export default usePagePermissions;
